import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function Residency() {
  useSEO(seoConfig.residency);

  return (
    <section className="contacts residency">
      <Breadcrumbs />
      <h1 className="contacts__title history__title">Ординатура</h1>

      <h3 className="about-nii__title antiCorruption__title">
        Информация для зачисленных в ординатуру в 2026г.
      </h3>

      <p className="dissertation__text">
        <b>02.09.2026 г.</b> состоится собрание ординаторов
        <br></br>В 10:00 для ординаторов 1 года обучения
        <br></br>В 11:00 для ординаторов 2 года обучения
        <br></br>По адресу г. Екатеринбург, ул.Щербакова, д.8 (1 этаж, Конференц
        зал)
      </p>

      <h3 className="about-nii__title antiCorruption__title">
        В ГБУ СО "УрНИИДВиИ" реализуется образовательная программа подготовки
        кадров высшей квалификации в ординатуре по специальности 31.08.32 -
        Дерматовенерология
      </h3>
      <p className="dissertation__text">
        В процессе обучения врачи получают знания по наиболее актуальным
        направлениям в области дерматовенерологии.
      </p>
      <p className="dissertation__text">
        Занятия и лекции проводят ведущие специалисты: 4 профессора, 8 докторов
        медицинских наук и 10 кандидатов медицинских наук.
      </p>
      <p className="dissertation__text">
        По окончании ординатуры, успешно сдавшим экзамены, выдаются документы
        установленного образца, утвержденные Государственным комитетом
        Российской Федерации по высшему образованию.
      </p>

      <div className="footer__middle_block">
        <Link
          to="/education/residency/scientific-educational"
          className="footer__link"
        >
          Научно - образовательный отдел
        </Link>
        <Link
          to="/education/residency/educational-program"
          className="footer__link"
        >
          Образовательная программа ординатуры
        </Link>
        <Link
          to="/education/residency/regulatory-documents"
          className="footer__link"
        >
          Нормативные документы
        </Link>
        <Link
          to="/education/residency/organization-monitoring"
          className="footer__link"
        >
          Организация мониторинга качества образования
        </Link>
        <Link to="/education/residency/clinical-base" className="footer__link">
          Клиническая база ГБУ СО "УрНИИДВиИ"
        </Link>
        <Link
          to="/education/residency/contingent-students"
          className="footer__link"
        >
          Контингент обучающихся в ординатуре: 2018 год
        </Link>
      </div>
    </section>
  );
}
